class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopHoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover)');
    this.hoverCloseTimer = null;
    this.onHoverOpen = this.onHoverOpen.bind(this);
    this.onHoverClose = this.onHoverClose.bind(this);
    this.bindDesktopHover();
    this.desktopHoverMedia.addEventListener('change', () => {
      this.unbindDesktopHover();
      this.bindDesktopHover();
    });
  }

  bindDesktopHover() {
    if (!this.desktopHoverMedia.matches) return;
    this.addEventListener('mouseenter', this.onHoverOpen);
    this.addEventListener('mouseleave', this.onHoverClose);
    this.mainDetailsToggle.addEventListener('mouseenter', this.onHoverOpen);
    this.mainDetailsToggle.addEventListener('mouseleave', this.onHoverClose);
  }

  unbindDesktopHover() {
    this.removeEventListener('mouseenter', this.onHoverOpen);
    this.removeEventListener('mouseleave', this.onHoverClose);
    this.mainDetailsToggle.removeEventListener('mouseenter', this.onHoverOpen);
    this.mainDetailsToggle.removeEventListener('mouseleave', this.onHoverClose);
  }

  onHoverOpen() {
    if (!this.desktopHoverMedia.matches) return;
    clearTimeout(this.hoverCloseTimer);
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'true');
    if (this.header) this.header.preventHide = true;
    this.onToggle();
  }

  onHoverClose() {
    if (!this.desktopHoverMedia.matches) return;
    clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = setTimeout(() => {
      this.close();
      if (this.header) this.header.preventHide = false;
    }, 250);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
